import { fetchReducerFactory } from '../../../shared/store/fetchFactory';

import {
  FETCH_OBLIGATIONS,
  FETCH_UPLOADED_OBLIGATIONS,
  FETCH_USER_ASSIGNED_COMPANY_CODES,
  FETCH_LOOKUP_DATA_FOR_OBLIGATIONS,
  UPDATE_OBLIGATION,
  CREATE_OBLIGATION,
  IMPORT_OBLIGATIONS,
  CLEAR_UPLOADED_OBLIGATIONS,
  DELETE_OBLIGATION,
} from './types';

import initialState from './initialState';

const fetchReducer = fetchReducerFactory({
  [FETCH_OBLIGATIONS]: 'Obligations',
  [FETCH_USER_ASSIGNED_COMPANY_CODES]: 'UserAssignedCompanyCodes',
  [FETCH_LOOKUP_DATA_FOR_OBLIGATIONS]: 'LookUpData',
  [UPDATE_OBLIGATION]: 'ObligationUpdate',
  [CREATE_OBLIGATION]: 'ObligationCreate',
  [FETCH_UPLOADED_OBLIGATIONS]: 'UploadedObligations',
  [IMPORT_OBLIGATIONS]: 'ObligationImport',
  [DELETE_OBLIGATION]: 'ObligationRemove',
}, initialState);

const obligationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_UPLOADED_OBLIGATIONS:
      return {
        ...state,
        uploadedObligations: initialState.uploadedObligations,
      };
    default:
      return fetchReducer(state, action);
  }
};

export default obligationsReducer;
